export default {
  no_mobile_app: 'No Mobile App configured',
  mobile_app_not_live: 'Mobile App Not Live',
};
